/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_Found_DescriptionInputs */

const en_not_found_description = /** @type {(inputs: Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The page you are looking for does not exist.`)
};

const pl_not_found_description = /** @type {(inputs: Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strona, której szukasz, nie istnieje.`)
};

/**
* | output |
* | --- |
* | "The page you are looking for does not exist." |
*
* @param {Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const not_found_description = /** @type {((inputs?: Not_Found_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_Found_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_not_found_description(inputs)
	return en_not_found_description(inputs)
});